import { render } from "./V-Header.vue?vue&type=template&id=33a5ff47"
import script from "./V-Header.vue?vue&type=script&lang=js"
export * from "./V-Header.vue?vue&type=script&lang=js"

import "./V-Header.vue?vue&type=style&index=0&id=33a5ff47&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__